/**
 * Fetch child comments (replies to `parentId`) for a given mediaPath.
 */

import { CommentService } from '@/domain/services/comment/commentService';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';
import type { PageCursor } from '@/data/types/json';
import type { CommentEntity } from '@/domain/entities/comment/commentEntity';

export interface FetchChildCommentsResult {
  comments: CommentEntity[];
  hasMore: boolean;
  cursor?: PageCursor;
}

export class FetchChildCommentsUseCase {
  constructor(private service = CommentService.getInstance()) {}

  async execute(
    mediaPath: string,
    parentId: string,
    cursor?: PageCursor,
    limit: number = SERVER_FETCH_CONSTANTS.COMMENT_CHILDREN_PAGINATION,
  ): Promise<FetchChildCommentsResult> {
    return this.service.fetchComments(mediaPath, parentId, limit, cursor);
  }
}

export const fetchChildCommentsUseCase = new FetchChildCommentsUseCase();
